export function isMobile(deviceType: string): boolean {
  return deviceType === 'mobile';
}

export function isSevenInchTablet(deviceType: string): boolean {
  return (
    !isMobile(deviceType) &&
    window.innerHeight < window.innerWidth &&
    window.innerHeight <= 308
  );
}

export function tabletSize(deviceType: string): string {
  const isSevenInch =
    !isMobile(deviceType) &&
    window.innerHeight < window.innerWidth &&
    window.innerHeight <= 631; // $tablet-10-inner-height - 1
  const isTenInch =
    !isMobile(deviceType) &&
    window.innerHeight < window.innerWidth &&
    window.innerHeight <= 895; // $tablet-22-inner-height -1
  const isTwentyTwoInch =
    !isMobile(deviceType) &&
    window.innerHeight < window.innerWidth &&
    window.innerHeight >= 896; // $tablet-22-inner-height

  const deviceSize = isSevenInch
    ? 'isSevenInch'
    : isTenInch
    ? 'isTenInch'
    : isTwentyTwoInch
    ? 'isTwentyTwoInch'
    : '';

  return deviceSize;
}
